const getters = {
    itemcategories: (state) => state.itemcategories,
    itemsubcategories: (state) => state.itemsubcategories,
    loading: state => state.loading
};

export default getters;